import React from "react";
import AppRoutes from '../routes';
import Header from "../components/sarphosaung/header";
import Footer from "../components/sarphosaung/footer";
import HomePage from "../pages/sarphosaung/home_page";
import AboutPage from "../pages/sarphosaung/about_page";
import ContactPage from "../pages/sarphosaung/contact_page";

export default function SarphosaungTemplate(props) {
    return (
        <React.Fragment>
            <Header />
            <AppRoutes
                homePage={HomePage}
                aboutPage={AboutPage}
                contactPage={ContactPage}
            />
            <Footer />
        </React.Fragment>
    );
}